import { render, staticRenderFns } from "./database-table.vue?vue&type=template&id=24f87ce6&scoped=true&"
import script from "./database-table.vue?vue&type=script&lang=ts&"
export * from "./database-table.vue?vue&type=script&lang=ts&"
import style0 from "./database-table.vue?vue&type=style&index=0&id=24f87ce6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f87ce6",
  null
  
)

export default component.exports